/**
 * Cockpit Service
 * 
 * Serviço para buscar dados de performance individual do usuário.
 */

import api from './api';

export const cockpitService = {
  /**
   * Buscar dados de performance individual do usuário logado
   * @param {Object} filters - Filtros opcionais (month, year)
   * @returns {Promise} Dados de performance
   */
  getPerformance: async (filters = {}) => {
    try {
      const response = await api.get('/api/cockpit/performance', { params: filters });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar dados de performance:', error);
      throw error;
    }
  }
};
